import styled from 'styled-components';

export const HeaderContainer = styled.header`
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  width: 100%;
  height: 94px;
  z-index: 10;
  pointer-events: auto;
  box-sizing: border-box;
  padding: 0 40px;
  opacity: ${props => props.$isPreloading ? '0' : '1'};
  visibility: ${props => props.$isPreloading ? 'hidden' : 'visible'};
  transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
  
  /* Ensure immediate interactivity */
  user-select: none;

  @media (max-width: 1200px) {
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 20px;
    height: auto;
    padding: 0 20px;
  }
`;

export const HeaderContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: auto;
  }
`;

export const LogoSection = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;

  @media (max-width: 768px) {
    position: relative;
    left: auto !important;
    top: auto !important;
    width: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  @media (max-width: 410px) {
    justify-content: space-between;
    overflow: visible;
  }
`;

export const MainLogo = styled.img`
  width: 164px;
  height: 42px;
  object-fit: contain;
  filter: ${props => props.$isCorporateMode ? 'invert(1)' : 'none'};
  transition: filter 0.5s ease-in-out;

  @media (max-width: 410px) {
    /* Scale logo individually to keep position relative to screen width */
    /* Account for 20px padding on each side, scale factor applied to width */
    width: calc(164px * ((80vw - 32px) / 358px));
    height: calc(42px * ((80vw - 32px) / 358px));
  }
`;

export const CorporateToggleContainer = styled.div`
  position: absolute;
  left: 0px;
  top: 54px;
  width: 194px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: 768px) {
    position: relative;
    left: auto !important;
    top: auto !important;
    margin-top: 0;
    justify-content: flex-end;
  }

  @media (max-width: 410px) {
    transform: scale(0.8);
    transform-origin: right center;
  }
`;

export const NavCenter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
  flex: 0 0 auto;
  height: 26px;
  position: absolute;
  left: 201px;
  top: 8px;

  @media (max-width: 1200px) {
    left: 180px;
    gap: 20px;
  }

  @media (max-width: 950px) {
    display: none;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const IdeasLab = styled.div`
  color: ${props => props.$isCorporateMode ? '#000' : '#FFF'};
  text-align: left;
  font-family: 'Generic-G80-RD-Standard-DEMO', -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  white-space: nowrap;
  transition: color 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const NavInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const RadicalText = styled.div`
  color: ${props => props.$isCorporateMode ? '#000' : '#FFF'};
  font-family: 'Generic-G80-RD-Standard-DEMO', -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.24px;
  white-space: nowrap;
  transition: color 0.5s ease-in-out;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const TrademarkIcon = styled.div`
  width: 9px;
  height: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavRight = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: 15px 15px;
  gap: 10px 20px;
  flex: 1;
  min-width: 0;
  height: 40px;
  position: absolute;
  right: 0;
  top: 1px;

  @media (max-width: 1200px) {
    gap: 10px 15px;
  }

  @media (max-width: 1000px) {
    gap: 10px 10px;
  }

  @media (max-width: 950px) {
    left: 200px;
    right: 0;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Locations = styled.div`
  display: contents;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    height: auto;
  }
`;

export const Metadata = styled.div`
  display: contents;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    height: auto;
  }
`;

export const AnimatedSpan = styled.span`
  color: ${props => props.$isCorporateMode ? '#000' : '#FFF'};
  font-family: 'Generic-G80-RD-Standard-DEMO', -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: ${props => props.$isMetadata ? '500' : '400'};
  line-height: normal;
  letter-spacing: 0.24px;
  text-transform: uppercase;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  height: 15px;

  @media (max-width: 1000px) {
    font-size: 11px;
  }

  @media (max-width: 768px) {
    white-space: normal;
    text-align: center;
    justify-content: center;
    height: auto;
  }
`;

